import {
  ADD_EXTRA_WORKING_DAY,
  DELETE_EXTRA_WORKING_DAY,
  EDIT_EXTRA_WORKING_DAY,
  EXTRA_WORKING_DAY_LIST,
  VIEW_EXTRA_WORKING_DAY,
} from "./apiRoutes";
import { authData } from "./Service";

export const addExtraWorkingDayApi = async (data) => {
  const response = await authData.post(ADD_EXTRA_WORKING_DAY, data);
  return response?.data;
};
export const editExtraWorkingDayApi = async (data) => {
  const response = await authData.put(`${EDIT_EXTRA_WORKING_DAY}`, data);
  return response?.data;
};
export const listOfExtraWorkingDayApi = async (data) => {
  const response = await authData.post(EXTRA_WORKING_DAY_LIST, data);
  return response?.data;
};
export const viewExtraWorkingDayApi = async (id) => {
  const response = await authData.delete(`${VIEW_EXTRA_WORKING_DAY}${id}`);
  return response?.data;
};
export const deleteExtraWorkingDayApi = async (id) => {
  const response = await authData.delete(`${DELETE_EXTRA_WORKING_DAY}${id}`);
  return response?.data;
};